import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

export default function SiteIntro() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-information-line"></i>
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {siteInfo.slogan}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{siteInfo.intro}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-700"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/related-info"
              className="inline-flex cursor-pointer items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              浏览相关资讯
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-px bg-background-200">
          {siteInfo.stats.map((item) => (
            <div key={item.label} className="flex flex-col justify-center bg-background-50 p-6 md:p-8">
              <span className="font-heading text-2xl font-bold text-accent-600 md:text-3xl">{item.value}</span>
              <span className="mt-1 text-sm text-foreground-600">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}